import {
  encode,
  decode,
  isObject,
  isArray,
  isDate,
  isNumber,
  isBoolean,
  isString,
  isFunction,
  typeForDisplay,
  isUndefined,
  isNull,
  clone,
  base64url,
} from './utils'
import type { FilterTree } from './filter'
import {
  filterBuilderFactory,
  platformizedFilterBuilder,
  PlatformizedFilterBuilder,
  filterMixin,
  validateFilterTree,
  validateFilterOrThrow,
  WithFilter,
} from './filter'
import { optimiseQuery, wixDataEncoder } from '@wix/filter-builder'
import {
  messages,
  codes,
  wixDataError,
  validationError,
  BulkError,
  apiValidator,
  AggregatingValidator,
  RejectingValidator,
} from './errors'
import sortMixin from './sort/sortMixin'
import {
  WixDataApi,
  WixDataQuery,
  WixDataResult,
  QueryValidator,
  WixDataOptions,
  WixDataReadOptions,
  WixDataReadWithProjectionOptions,
  WixDataUpdateOptions,
  WixDataQueryOptions,
  WixDataItem,
  WixDataReference,
  WixDataBulkError,
  WixDataBulkResult,
} from './api'
import type { HttpApiClientFactory, RequestInterceptor } from './types'
import type { WixDataItemOrId } from './api'

export type {
  FilterTree,
  HttpApiClientFactory,
  RequestInterceptor,
  WixDataItemOrId,
}
export * from './types'
export {
  encode,
  decode,
  isObject,
  isArray,
  isDate,
  isNumber,
  isBoolean,
  isString,
  isFunction,
  typeForDisplay,
  isUndefined,
  isNull,
  clone,
  base64url,
  filterMixin,
  filterBuilderFactory,
  platformizedFilterBuilder,
  PlatformizedFilterBuilder,
  optimiseQuery,
  validateFilterOrThrow,
  validateFilterTree,
  wixDataEncoder,
  WithFilter,
  messages,
  codes,
  wixDataError,
  validationError,
  BulkError,
  apiValidator,
  AggregatingValidator,
  RejectingValidator,
  sortMixin,
  WixDataApi,
  WixDataQuery,
  WixDataResult,
  QueryValidator,
  WixDataOptions,
  WixDataReadOptions,
  WixDataReadWithProjectionOptions,
  WixDataUpdateOptions,
  WixDataQueryOptions,
  WixDataItem,
  WixDataReference,
  WixDataBulkError,
  WixDataBulkResult,
}
